'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var notfound = exports.notfound = {
  title: '404 Error',
  description: "We're sorry, but the page you're looking for does not exist. Would you like to go back?",
  goback: 'Take me back'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/notfound.js
// module id = 719
// module chunks = 0